import React from 'react';
import {t} from "i18next";

export default function ApplySuccess() {
  return (
    <div className="col-md-8 offset-md-2 offset-lg-3 col-lg-6">
      <div className="card mt-3">
        <div className="card-body">
          <h4 className="card-title mb-4">{t('apply.success.heading')}</h4>
          <p>{t('apply.success.paragraph')}</p>
        </div>
      </div>
    </div>
  );
}
